import React, { Component } from 'react';
import { connect } from 'react-redux';
import _ from 'lodash'

import {Container} from 'reactstrap';
import Header from '../core/Header/';
import Sidebar from '../core/Sidebar/';
import Aside from '../core/Aside/';
import Footer from '../core/Footer/';

import { changeSubSection } from '../../actions/app';
import { fetchUser, singOutUser, markAllNotifications } from '../../actions/';
import Notification from '../common/Notification'



export default function(ComposedComponent) {
    class Authentication extends Component {
        static contextTypes = {
            router: React.PropTypes.object
        }
        componentDidMount(){
            this.props.fetchUser();
            if(_.isEmpty(this.props.user)){ return }
            if(this.props.location && this.props.user.admin != 1 && this.props.location.pathname.indexOf("admin") > -1){
                this.context.router.history.push('/');
            }
        }

        componentWillMount() {
            if (!this.props.authenticated) {
                this.context.router.history.push('/login');
            }
        }

        componentWillUpdate(nextProps) {
            if (!nextProps.authenticated) {
                this.context.router.history.push('/login');
            }
            if(_.isEmpty(this.props.user)){ return }
            if(this.props.location && this.props.user.admin != 1 && this.props.location.pathname.indexOf("admin") > -1){
                this.context.router.history.push('/');
            }
        }
        render() {
            return(
                <div className="app">
                    <Notification message={this.props.activeSection} />
                    <Header
                        signOut={this.props.singOutUser}
                        notifications={this.props.notifications}
                        {...this.props}
                    />
                    <div className="app-body">
                        <Sidebar
                            {...this.props}
                        />
                        <main className="main">
                            <div className="sub-main">
                                <Container fluid>
                                    <ComposedComponent {...this.props} />
                                </Container>
                            </div>
                        </main>
                        <Aside
                            markAllNotifications={this.props.markAllNotifications.bind(this)}
                            notifications={this.props.notifications}
                        />
                    </div>
                    <Footer />
                </div>
                )
        }
    }

    function mapStateToProps(state) {
        return {
            authenticated: state.auth.authenticated,
            activeSection: state.activeSection,
            user: state.user,
            caso: state.caso,
            status: state.caso.status,
            notifications: state.notifications
        };
    }

    return connect(mapStateToProps, {
        changeSubSection,
        fetchUser,
        singOutUser,
        markAllNotifications
    })(Authentication);
}



// WEBPACK FOOTER //
// ./resources/assets/js/components/auth/require_authentication.jsx